(() => {
  const key = 'moebe-wishlist-v1';
  const dialog = document.getElementById('MoebeWishlist');
  const stringsElement = document.getElementById('MoebeWishlistStrings');
  if (!dialog || !stringsElement) return;
  const strings = JSON.parse(stringsElement.textContent);
  const status = document.querySelector('[data-moebe-wishlist-status]');
  const list = dialog.querySelector('[data-moebe-wishlist-list]');
  const drawer = new theme.Drawers('MoebeWishlist', 'moebe-wishlist');
  const shareButton = dialog.querySelector('[data-wishlist-share]');
  const sharedNotice = dialog.querySelector('[data-wishlist-shared]');
  const shareStatus = dialog.querySelector('[data-wishlist-share-status]');
  const shareLink = dialog.querySelector('[data-wishlist-link]');
  const titleElement = dialog.querySelector('#MoebeWishlistTitle');
  const personalTitle = titleElement.textContent;
  const de = document.documentElement.lang.startsWith('de');
  const labels = de ? {
    shared: 'Geteilte Wunschliste', copied: 'Link kopiert', copy: 'Link zum Kopieren', invalid: 'Dieser Wunschlisten-Link ist ungültig.',
    saved: 'Zu deiner Wunschliste hinzugefügt.', limit: 'Deine Wunschliste ist voll (200 Artikel). Entferne zuerst einen Artikel.',
    unavailable: 'Diese Variante ist derzeit nicht verfügbar.', failed: 'Produkt konnte nicht geladen werden. Bitte erneut öffnen.', loading: 'Wird geladen …'
  } : {
    shared: 'Shared wishlist', copied: 'Link copied', copy: 'Link to copy', invalid: 'This wishlist link is invalid.',
    saved: 'Added to your wishlist.', limit: 'Your wishlist is full (200 items). Remove an item first.',
    unavailable: 'This variant is currently unavailable.', failed: 'Could not load this product. Please reopen to retry.', loading: 'Loading …'
  };
  let items = [];
  let sharedItems = null;
  let refreshToken = 0;
  const validItem = item => item && /^[1-9][0-9]{0,19}$/.test(String(item.id)) && typeof item.handle === 'string' && /^[a-z0-9-]{1,255}$/.test(item.handle);
  const viewItems = () => sharedItems === null ? items : sharedItems;
  const showStatus = text => { shareStatus.textContent = text; announce(text); };
  function closeDrawer() { drawer.close(); dialog.setAttribute('aria-hidden', 'true'); }
  const originalClose = drawer.close.bind(drawer);
  drawer.close = function(event) { originalClose(event); if (!drawer.isOpen) dialog.setAttribute('aria-hidden','true'); };
  function openDrawer(source) {
    document.dispatchEvent(new CustomEvent('cart:close'));
    document.dispatchEvent(new CustomEvent('modalOpen'));
    render();
    dialog.removeAttribute('aria-hidden');
    drawer.open(null, source);
    refresh();
  }

  const addingIds = new Set();
  try {
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) items = saved.filter(item => validItem(item)).slice(0,200);
  } catch (_) {}
  const announce = text => { status.textContent = text; };
  const currency = () => window.Shopify?.currency?.active || document.querySelector('[data-moebe-wishlist-product]')?.dataset.currency || 'EUR';
  function money(cents, code) {
    const value = Number(cents) / 100;
    const number = new Intl.NumberFormat(code === 'DKK' ? 'da-DK' : 'en-GB', { maximumFractionDigits: value % 1 ? 2 : 0 }).format(value);
    if (code === 'EUR') return '€' + number;
    if (code === 'GBP') return '£' + number;
    if (code === 'DKK') return number + ' kr';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:code}).format(value);
  }
  function selected(wrapper) {
    const variants = JSON.parse(wrapper.querySelector('[data-moebe-wishlist-variants]').textContent);
    const form = document.getElementById(wrapper.dataset.formId);
    const id = form?.querySelector('[name="id"]')?.value || wrapper.dataset.variantId;
    return variants.find(v => String(v.id) === String(id));
  }
  function sync() {
    document.querySelectorAll('[data-moebe-wishlist-open]').forEach(opener => {
      const bubble = opener.querySelector('[data-moebe-wishlist-bubble]');
      if (bubble) {
        bubble.hidden = items.length === 0;
        bubble.classList.toggle('cart-link__bubble--visible', items.length > 0);
      }
      const label = opener.querySelector('.icon__fallback-text')?.textContent.trim() || personalTitle;
      opener.setAttribute('aria-label', items.length ? label + ' (' + items.length + ')' : label);
    });
    document.querySelectorAll('[data-moebe-wishlist-product]').forEach(wrapper => {
      const variant = selected(wrapper);
      const saved = variant && items.some(item => String(item.id) === String(variant.id));
      wrapper.querySelector('[data-moebe-wishlist-save]').setAttribute('aria-pressed', String(Boolean(saved)));
      wrapper.querySelector('[data-moebe-wishlist-label]').textContent = saved ? strings.added : strings.add;
    });
  }
  function persist(next) {
    if (next.length > 200) { showStatus(labels.limit); return false; }
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch (_) { announce(strings.error); return false; }
    items = next; sync(); return true;
  }
  function safeImage(src) {
    if (!src) return '';
    try { const url = new URL(src, location.origin); return url.protocol === 'https:' ? url.href : ''; }
    catch (_) { return ''; }
  }
  function productUrl(item) {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root + 'products/' + encodeURIComponent(item.handle), location.origin);
    url.searchParams.set('variant',item.id);
    if (dialog.dataset.previewTheme) url.searchParams.set('preview_theme_id',dialog.dataset.previewTheme);
    return url.href;
  }
  function render() {
    list.replaceChildren();
    const visible = viewItems();
    dialog.querySelector('[data-moebe-wishlist-empty]').hidden = visible.length > 0;
    sharedNotice.hidden = sharedItems === null;
    titleElement.textContent = sharedItems === null ? personalTitle : labels.shared;
    shareButton.disabled = !visible.length;
    dialog.querySelector('[data-wishlist-merge]').disabled = !visible.length;
    shareLink.hidden = true;
    visible.forEach(item => {
      const row = document.createElement('div'); row.className = 'cart__item moebe-wishlist-item';
      const imageLink = document.createElement('a'); imageLink.href = productUrl(item); imageLink.setAttribute('aria-label',item.title);
      const imageWrap = document.createElement('div'); imageWrap.className = 'cart__image'; imageWrap.append(imageLink);
      const src = safeImage(item.image);
      if (src) { const image = document.createElement('img'); image.src = src; image.alt = item.title; image.loading = 'lazy'; imageLink.append(image); }
      const details = document.createElement('div'); details.className = 'cart__item-details';
      const titleWrap = document.createElement('div'); titleWrap.className = 'cart__item-title';
      const title = document.createElement('a'); title.href = productUrl(item); title.textContent = item.title;
      title.className = 'cart__item-name'; titleWrap.append(title); details.append(titleWrap);
      if (item.variantTitle && item.variantTitle !== 'Default Title') { const variant = document.createElement('p'); variant.className = 'cart__item--variants'; variant.textContent = item.variantTitle; titleWrap.append(variant); }
      if (!item.contract && !item.loadError && !item.loading && item.currency === currency()) { const price = document.createElement('p'); price.className = 'cart__price'; price.textContent = money(item.price,item.currency); titleWrap.append(price); }
      const actions = document.createElement('div'); actions.className = 'moebe-wishlist-actions';
      const feedback = document.createElement('p'); feedback.className = 'moebe-wishlist-feedback'; feedback.setAttribute('role', 'status'); feedback.hidden = true;
      if (!item.contract && !item.loading && !item.loadError && item.available !== false) {
        const addToCart = document.createElement('button'); addToCart.type = 'button';
        addToCart.textContent = addingIds.has(String(item.id)) ? strings.cartAdding : strings.cartAdd;
        addToCart.disabled = addingIds.has(String(item.id));
        addToCart.setAttribute('aria-label', strings.cartAdd + ': ' + item.title + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : ''));
        addToCart.addEventListener('click', async () => {
          const id = String(item.id);
          if (addingIds.has(id)) return;
          addingIds.add(id); addToCart.disabled = true; addToCart.textContent = strings.cartAdding; feedback.hidden = true;
          let product;
          let added = false;
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({id: item.id, quantity: 1})
            });
            product = await response.json();
            if (!response.ok || product.status) throw new Error(product.description || product.message || strings.cartError);
            added = true;
          } catch (error) {
            feedback.textContent = error.message || strings.cartError; feedback.hidden = false;
          } finally {
            addingIds.delete(id); addToCart.disabled = false; addToCart.textContent = strings.cartAdd;
          }
          if (added) {
            announce(strings.cartAdded);
            closeDrawer();
            // Let the existing drawer finish closing before the cart takes focus.
            window.setTimeout(() => document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {product, addToCartBtn: addToCart}})), 510);
          }
        });
        actions.append(addToCart);
      }
      if (item.loading || item.loadError || item.available === false) {
        const note = document.createElement('p'); note.textContent = item.loading ? labels.loading : item.loadError ? labels.failed : labels.unavailable;
        titleWrap.append(note);
      }
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = strings.remove; remove.setAttribute('aria-label', strings.remove + ': ' + item.title);
      remove.addEventListener('click',()=>{ if (persist(items.filter(saved => String(saved.id) !== String(item.id)))) { render(); announce(strings.removed); const next = list.querySelector('button'); (next || dialog.querySelector('[data-moebe-wishlist-close]')).focus(); } });
      if (sharedItems === null) actions.append(remove); details.append(actions, feedback); row.append(imageWrap,details); list.append(row);
    });
  }
  async function refresh() {
    const token = ++refreshToken;
    const source = viewItems();
    const root = window.Shopify?.routes?.root || '/';
    const products = new Map();
    const updated = source.map(item => ({...item}));
    let cursor = 0;
    await Promise.all(Array.from({length:Math.min(6,updated.length)}, async () => {
      while (cursor < updated.length) {
        const item = updated[cursor++];
        try {
          if (!products.has(item.handle)) products.set(item.handle, (async () => {
            const response = await fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js', {signal:AbortSignal.timeout(12000)});
            if (response.status === 404) return null;
            if (!response.ok) throw new Error('Product request failed');
            return response.json();
          })());
          const product = await products.get(item.handle);
          const variant = product?.variants?.find(v => String(v.id) === String(item.id));
          item.loading = false; item.loadError = false;
          if (!variant) { item.available = false; continue; }
          Object.assign(item, {price:variant.price, currency:currency(), title:product.title,
            variantTitle:variant.title, image:variant.featured_image?.src || product.featured_image,
            available:variant.available});
        } catch (_) { item.loading = false; item.loadError = true; }
      }
    }));
    if (token !== refreshToken || source !== viewItems()) return;
    if (sharedItems === null) items = updated; else sharedItems = updated;
    if (drawer.isOpen) render();
  }
  function shareUrl() {
    const url = new URL(window.Shopify?.routes?.root || '/', location.origin);
    if (dialog.dataset.previewTheme) url.searchParams.set('preview_theme_id',dialog.dataset.previewTheme);
    const payload = {v:1,items:viewItems().map(item => [item.handle,String(item.id),Boolean(item.contract)])};
    url.hash = 'wishlist=' + btoa(JSON.stringify(payload)).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    return url.href;
  }
  shareButton.addEventListener('click', async () => {
    const url = shareUrl();
    shareLink.value = url; shareLink.hidden = false;
    try {
      if (navigator.share && (!navigator.canShare || navigator.canShare({url}))) {
        await navigator.share({title:'MOEBE Wishlist',url}); return;
      }
    } catch (error) { if (error.name === 'AbortError') return; }
    try { await navigator.clipboard.writeText(url); showStatus(labels.copied); }
    catch (_) { shareLink.focus(); shareLink.select(); showStatus(labels.copy); }
  });
  dialog.querySelector('[data-wishlist-mine]').addEventListener('click', () => {
    sharedItems = null; ++refreshToken;
    if (location.hash.startsWith('#wishlist=')) history.replaceState(null,'',location.pathname + location.search);
    showStatus(''); render(); refresh();
  });
  dialog.querySelector('[data-wishlist-merge]').addEventListener('click', () => {
    if (sharedItems === null) return;
    const ids = new Set(items.map(item => String(item.id)));
    const next = [...items,...sharedItems.filter(item => !ids.has(String(item.id)))];
    if (persist(next)) showStatus(labels.saved);
  });
  function openShared() {
    if (!location.hash.startsWith('#wishlist=')) return;
    try {
      const encoded = location.hash.slice(10);
      if (encoded.length > 100000 || !/^[A-Za-z0-9_-]+$/.test(encoded)) throw new Error();
      const payload = JSON.parse(atob(encoded.replace(/-/g,'+').replace(/_/g,'/')));
      if (payload.v !== 1 || !Array.isArray(payload.items) || !payload.items.length || payload.items.length > 200) throw new Error();
      const ids = new Set();
      const decoded = payload.items.map(entry => {
        if (!Array.isArray(entry) || entry.length !== 3 || typeof entry[2] !== 'boolean') throw new Error();
        const item = {handle:entry[0],id:entry[1],contract:entry[2]};
        if (!validItem(item) || ids.has(String(item.id))) throw new Error();
        ids.add(String(item.id));
        return {...item,title:item.handle.replace(/-/g,' '),variantTitle:'Variant ' + item.id,loading:true};
      });
      sharedItems = decoded; showStatus(''); openDrawer();
    } catch (_) { sharedItems = null; openDrawer(); showStatus(labels.invalid); }
  }
  window.addEventListener('hashchange',openShared);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-moebe-wishlist-open]');
    if (opener) { event.preventDefault(); event.stopPropagation(); sharedItems = null; showStatus(''); openDrawer(opener); return; }
    const save = event.target.closest('[data-moebe-wishlist-save]');
    if (!save) return;
    const wrapper = save.closest('[data-moebe-wishlist-product]');
    const variant = selected(wrapper);
    if (!variant) { announce(strings.unavailable); return; }
    const exists = items.some(item => String(item.id) === String(variant.id));
    const item = {id:variant.id,handle:wrapper.dataset.productHandle,title:wrapper.dataset.productTitle,variantTitle:variant.title,price:variant.price,currency:wrapper.dataset.currency,image:variant.featured_image?.src || JSON.parse(wrapper.querySelector('[data-moebe-wishlist-image]').textContent),contract:wrapper.dataset.contract === 'true'};
    const next = exists ? items.filter(item => String(item.id) !== String(variant.id)) : [...items,item];
    if (persist(next)) { announce(exists ? strings.removed : strings.added); if (!exists) { event.stopPropagation(); sharedItems = null; openDrawer(save); } }
  });
  document.addEventListener('variant:change',sync);
  document.addEventListener('change',()=>setTimeout(sync,0));
  document.addEventListener('shopify:section:load',sync);
  window.addEventListener('storage',event=>{ if (event.key === key) { try { const value = JSON.parse(event.newValue || '[]'); items = Array.isArray(value) ? value.filter(validItem).slice(0,200) : []; sync(); if (drawer.isOpen) { render(); refresh(); } } catch (_) {} } });
  sync();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',openShared,{once:true}); else openShared();
})();

